var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0251 13.9049C16.3064 14.2174 16.3064 14.6862 15.9939 14.9674L15.1189 15.8424C14.8376 16.1549 14.3689 16.1549 14.0564 15.8424L10.9626 12.7487C10.8064 12.5924 10.7439 12.4049 10.7439 12.2174V11.6862C9.6189 12.5612 8.2439 13.0612 6.7439 13.0612C3.15015 13.0612 0.243896 10.1549 0.243896 6.56116C0.243896 2.99866 3.15015 0.0611572 6.7439 0.0611572C10.3064 0.0611572 13.2439 2.99866 13.2439 6.56116C13.2439 8.09241 12.7126 9.46741 11.8689 10.5612H12.3689C12.5564 10.5612 12.7439 10.6549 12.9001 10.7799L16.0251 13.9049ZM6.7439 10.5612C8.9314 10.5612 10.7439 8.77991 10.7439 6.56116C10.7439 4.37366 8.9314 2.56116 6.7439 2.56116C4.52515 2.56116 2.7439 4.37366 2.7439 6.56116C2.7439 8.77991 4.52515 10.5612 6.7439 10.5612Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d6a6598cd9f87bd7b689e8dd08848020.svg";
export { ForwardRef as ReactComponent };